export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_13.a38f6462.jpg";